import { useLocation } from "react-router-dom";

export function useAppBasePath() {
  const { pathname } = useLocation();

  return pathname.startsWith("/admin")
    ? "/admin"
    : "/home";
}